import styled from 'styled-components'
import { BoxIcon } from 'secondstep-components'
import { Button } from 'grommet'
import { themeGet } from 'styled-system'

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledButton = styled(Button)`
  display: flex;
  justify-content: space-between;
  span {
    display: flex;
    align-items: center;
  }
  svg {
    margin: -10px 0rem 0.1875rem 0;
  }
  color: ${themeGet('colors.themeAccent')};
  font-weight: 400;
  font-family: ${themeGet('font.molde.medium')};
`

export const IconBox = styled(BoxIcon).attrs(props => ({
  fill: themeGet('colors.themeAccent')(props),
  height: '15px',
  viewBox: '0 0 15 15',
  width: '15px',
}))`
  width: 15px !important;
  height: 15px !important;
  padding-right: 10px;
  margin: -1px 0 0 0 !important;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0;

  &:hover {
    cursor: pointer;
    ${StyledButton} {
      color: ${props => themeGet('colors.themePrimary')(props)};
    }
    ${IconBox} g > path {
      fill: ${props => themeGet('colors.themePrimary')(props)};
    }
  }
`
